// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import theme from "./theme";

// ==============================|| COMBINE REDUCERS ||============================== //

const persistConfig = {
  key: "root", // The key to use for storing the data in local storage
  storage, // The storage engine to use for persistence
  whitelist: ["user"], // Array of reducer names to persist
  // Optionally, you can configure blacklist to exclude certain reducers from being persisted
  // blacklist: ['auth'],
};

const appReducer = combineReducers({
  theme,
});

const persistedReducer = persistReducer(persistConfig, appReducer);

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    return persistedReducer(undefined, action);
  }

  return persistedReducer(state, action);
};

export default rootReducer;
